import { useLang } from "@/contexts/LangContext";

function PageShell({ title, children, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid={testId}>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 mb-6 pb-4 border-b border-slate-200">
        {title}
      </h1>
      <div className="prose prose-slate max-w-none space-y-4 text-slate-700 leading-relaxed text-[15px]">
        {children}
      </div>
    </div>
  );
}

export function AboutPage() {
  const { lang } = useLang();
  return (
    <PageShell testId="about-page" title={lang === "hi" ? "हमारे बारे में" : "About Naukri Suchna"}>
      <p>
        {lang === "hi"
          ? "नौकरी सूचना एक स्वतंत्र भारतीय करियर सूचना पोर्टल है जो सरकारी नौकरियों, परिणामों, प्रवेश पत्रों, उत्तर कुंजियों, पाठ्यक्रम, प्रवेश और छात्रवृत्ति की अधिसूचनाओं को एक ही स्थान पर लाता है।"
          : "Naukri Suchna is an independent Indian career information portal that brings government job notifications, results, admit cards, answer keys, syllabus, admissions and scholarship updates into one clean, mobile-first feed."}
      </p>
      <p>
        {lang === "hi"
          ? "यह वेबसाइट किसी भी सरकारी संस्था से संबद्ध नहीं है। हम केवल आधिकारिक अधिसूचनाओं के संक्षिप्त सार और लिंक प्रस्तुत करते हैं। किसी भी आवेदन से पहले आधिकारिक स्रोत की पुष्टि अवश्य करें।"
          : "We are not affiliated with any government body. We only publish concise summaries and links pointing to official government notifications. Please always verify from the official source before applying."}
      </p>
    </PageShell>
  );
}

export function ContactPage() {
  const { lang } = useLang();
  return (
    <PageShell testId="contact-page" title={lang === "hi" ? "संपर्क करें" : "Contact Us"}>
      <p>
        {lang === "hi"
          ? "किसी भी प्रश्न, फीडबैक या सुधार सुझाव के लिए हमें लिखें:"
          : "For any question, feedback or correction request, write to us at:"}
      </p>
      <p className="font-mono-tabular text-slate-900">
        <strong>Email:</strong> contact@naukrisuchna.in
      </p>
    </PageShell>
  );
}

export function PrivacyPage() {
  const { lang } = useLang();
  return (
    <PageShell testId="privacy-page" title="Privacy Policy">
      <p>
        {lang === "hi"
          ? "हम आगंतुकों की न्यूनतम जानकारी संग्रहित करते हैं। कोई भी व्यक्तिगत जानकारी बिना सहमति के साझा नहीं की जाती।"
          : "We collect minimal visitor information. No personal information is shared without consent."}
      </p>
      <p>
        {lang === "hi"
          ? "इस साइट पर सामान्य वेब लॉग जैसे IP पता, ब्राउज़र प्रकार और विज़िट किए गए पृष्ठ रिकॉर्ड किए जा सकते हैं ताकि सेवा में सुधार किया जा सके।"
          : "Standard web logs such as IP address, browser type and pages visited may be recorded to improve the service."}
      </p>
    </PageShell>
  );
}

export function DisclaimerPage() {
  const { lang } = useLang();
  return (
    <PageShell testId="disclaimer-page" title="Disclaimer">
      <p>
        {lang === "hi"
          ? "यह वेबसाइट भारत सरकार की आधिकारिक वेबसाइट नहीं है। हम आधिकारिक अधिसूचनाओं के लिंक और सारांश प्रदान करते हैं। कृपया आवेदन से पहले हमेशा आधिकारिक स्रोत की पुष्टि करें।"
          : "This website is not an official Government of India website. We provide links and summaries to help candidates discover official notifications. Please always verify from the official source before applying."}
      </p>
      <p>
        {lang === "hi"
          ? "\"DEMO\" के रूप में चिह्नित पोस्ट केवल प्रदर्शन के लिए हैं और वास्तविक अधिसूचना नहीं हैं।"
          : "Posts labelled \"[DEMO]\" are for demonstration only and are NOT real notifications."}
      </p>
    </PageShell>
  );
}

export function TermsPage() {
  const { lang } = useLang();
  return (
    <PageShell testId="terms-page" title="Terms & Conditions">
      <p>
        {lang === "hi"
          ? "इस साइट का उपयोग करके, आप सहमत हैं कि आप इसका उपयोग केवल कानूनी और व्यक्तिगत उद्देश्यों के लिए करेंगे।"
          : "By using this site, you agree to use it only for lawful, personal purposes."}
      </p>
      <p>
        {lang === "hi"
          ? "साइट पर सामग्री \"जैसी है\" प्रदान की जाती है। हम अधिकतम सटीकता का प्रयास करते हैं लेकिन आधिकारिक स्रोत सर्वोच्च है।"
          : "Content on the site is provided \"as is\". We strive for maximum accuracy but the official source always prevails."}
      </p>
    </PageShell>
  );
}
